import * as d3 from "d3";

export const stackedData = [
  {
    id: "1",
    Month: "Jan",
    US: "20000",
    Europe: "14500",
    Asia: "26000",
    SouthAmerica: "8500",
  },
  {
    id: "2",
    Month: "Feb",
    US: "22000",
    Europe: "14600",
    Asia: "24000",
    SouthAmerica: "8700",
  },
  {
    id: "3",
    Month: "Mar",
    US: "19000",
    Europe: "14500",
    Asia: "24500",
    SouthAmerica: "9000",
  },
  {
    id: "4",
    Month: "Apr",
    US: "23000",
    Europe: "14450",
    Asia: "27000",
    SouthAmerica: "5500",
  },
  {
    id: "5",
    Month: "May",
    US: "24000",
    Europe: "16000",
    Asia: "22000",
    SouthAmerica: "5000",
  },
  {
    id: "6",
    Month: "June",
    US: "18000",
    Europe: "12000",
    Asia: "18500",
    SouthAmerica: "4500",
  },
  {
    id: "7",
    Month: "July",
    US: "12000",
    Europe: "9500",
    Asia: "13500",
    SouthAmerica: "6500",
  },
  {
    id: "8",
    Month: "Aug",
    US: "14500",
    Europe: "11000",
    Asia: "13700",
    SouthAmerica: "4000",
  },
  {
    id: "9",
    Month: "Sep",
    US: "18400",
    Europe: "12500",
    Asia: "19000",
    SouthAmerica: "7500",
  },
  {
    id: "10",
    Month: "Oct",
    US: "16000",
    Europe: "12000",
    Asia: "16500",
    SouthAmerica: "6800",
  },
  {
    id: "11",
    Month: "Nov",
    US: "21000",
    Europe: "14000",
    Asia: "22000",
    SouthAmerica: "6900",
  },
  {
    id: "12",
    Month: "Dec",
    US: "22500",
    Europe: "15500",
    Asia: "24000",
    SouthAmerica: "8000",
  },
];

export const groupData = [
  { id: "1", month: "Jan", petrolprice: "55", dieselprice: "35" },
  { id: "2", month: "Feb", petrolprice: "58", dieselprice: "37" },
  { id: "3", month: "Mar", petrolprice: "67", dieselprice: "48" },
  { id: "4", month: "Apr", petrolprice: "79", dieselprice: "59" },
  { id: "5", month: "May", petrolprice: "105", dieselprice: "81" },
  { id: "6", month: "June", petrolprice: "125", dieselprice: "102" },
  { id: "7", month: "July", petrolprice: "127", dieselprice: "102" },
  { id: "8", month: "Aug", petrolprice: "141", dieselprice: "123" },
  { id: "9", month: "Sep", petrolprice: "104", dieselprice: "81" },
  { id: "10", month: "Oct", petrolprice: "90", dieselprice: "68" },
  { id: "11", month: "Nov", petrolprice: "79", dieselprice: "57" },
  { id: "12", month: "Dec", petrolprice: "68", dieselprice: "45" },
];

export const pieData = [
  {
    id: "1",
    country: "US",
    shortName: "US",
    value: "333.3",
    subState: [
      { id: "101", country: "California", value: "39.5" },
      { id: "102", country: "Texas", value: "29.1" },
      { id: "103", country: "Florida", value: "21.5" },
      { id: "104", country: "New York", value: "20.2" },
      { id: "105", country: "Ohio", value: "11.7" },
    ],
  },
  {
    id: "2",
    country: "China",
    shortName: "CN",
    value: "1425.7",
    subState: [
      { id: "201", country: "Guangdong", value: "115" },
      { id: "202", country: "Shandong", value: "110" },
      { id: "203", country: "Henan", value: "95" },
      { id: "204", country: "Sichuan", value: "83" },
      { id: "205", country: "Jiangsu", value: "80" },
    ],
  },
  {
    id: "3",
    country: "Indonesia",
    shortName: "Indo",
    value: "275.5",
    subState: [
      { id: "301", country: "Sumatra", value: "59" },
      { id: "302", country: "Kailmanthan", value: "17" },
      { id: "303", country: "Sulawesi", value: "20" },
      { id: "304", country: "West Java", value: "50" },
      { id: "305", country: "Banten", value: "12" },
    ],
  },
  {
    id: "4",
    country: "Pakistan",
    shortName: "Pak",
    value: "235.8",
    subState: [
      { id: "401", country: "Punjab", value: "70" },
      { id: "402", country: "Sindh", value: "60" },
      { id: "403", country: "Khyber Pakhtunkhwa", value: "40" },
      { id: "404", country: "Balochistan", value: "25" },
      { id: "405", country: "Islamabad", value: "22" },
    ],
  },
  {
    id: "5",
    country: "India",
    shortName: "Ind",
    value: "1425.8",
    subState: [
      { id: "501", country: "Gujarat", value: "63" },
      { id: "502", country: "Rajasthan", value: "78" },
      { id: "503", country: "Uttar Pradesh", value: "230" },
      { id: "504", country: "Tamil Nadu", value: "78" },
      { id: "505", country: "Maharashtra", value: "120" },
    ],
  },
];

export const candleData = [
  { id: "1", date: "2023-04-01", open: 423.00, high: 424.95, low: 419.50, close: 424.25 },
  { id: "2", date: "2023-04-02", open: 424.25, high: 428.75, low: 423.15, close: 426.55 },
  { id: "3", date: "2023-04-03", open: 426.50, high: 439.30, low: 423.75, close: 437.65 },
  { id: "4", date: "2023-04-04", open: 452.05, high: 473.30, low: 452.00, close: 461.30 },
  { id: "5", date: "2023-04-05", open: 463.75, high: 463.75, low: 455.80, close: 458.70 },
  { id: "6", date: "2023-04-06", open: 459.35, high: 468.60, low: 458.20, close: 465.50 },
  { id: "7", date: "2023-04-07", open: 464.95, high: 472.00, low: 463.25, close: 469.50 },
  { id: "8", date: "2023-04-08", open: 471.00, high: 473.00, low: 465.65, close: 472.15 },
  { id: "9", date: "2023-04-09", open: 475.00, high: 483.35, low: 468.10, close: 473.00 },
  { id: "10", date: "2023-04-10", open: 473.00, high: 475.50, low: 467.85, close: 469.40 },
  { id: "11", date: "2023-04-11", open: 473.70, high: 479.70, low: 469.40, close: 476.80 },
  { id: "12", date: "2023-04-12", open: 476.70, high: 476.70, low: 467.20, close: 471.20 },
  { id: "13", date: "2023-04-13", open: 471.20, high: 476.00, low: 468.30, close: 475.20 },
  { id: "14", date: "2023-04-14", open: 475.20, high: 476.40, low: 471.90, close: 473.55 },
  { id: "15", date: "2023-04-15", open: 473.00, high: 479.50, low: 472.60, close: 478.20 },
  { id: "16", date: "2023-04-16", open: 478.50, high: 482.00, low: 476.50, close: 481.60 },
  { id: "17", date: "2023-04-17", open: 481.40, high: 488.00, low: 478.35, close: 484.95 },
  { id: "18", date: "2023-04-18", open: 482.50, high: 484.00, low: 474.55, close: 480.25 },
  { id: "19", date: "2023-04-19", open: 480.25, high: 485.10, low: 477.75, close: 483.70 },
  { id: "20", date: "2023-04-20", open: 483.60, high: 486.40, low: 478.75, close: 480.80 },
  { id: "21", date: "2023-04-21", open: 481.65, high: 484.70, low: 476.15, close: 477.10 },
  { id: "22", date: "2023-04-22", open: 480.00, high: 502.30, low: 478.10, close: 500.50 },
  { id: "23", date: "2023-04-23", open: 502.00, high: 512.80, low: 501.55, close: 503.65 },
  { id: "24", date: "2023-04-24", open: 508.00, high: 512.90, low: 504.35, close: 509.50 },
  { id: "25", date: "2023-04-25", open: 512.00, high: 514.15, low: 505.50, close: 511.60 },
  { id: "26", date: "2023-04-26", open: 513.90, high: 520.50, low: 510.30, close: 515.95 },
  { id: "27", date: "2023-04-27", open: 523.85, high: 537.15, low: 521.50, close: 530.85 },
  { id: "28", date: "2023-04-28", open: 533.95, high: 535.95, low: 518.85, close: 521.15 },
  { id: "29", date: "2023-04-29", open: 522.50, high: 523.95, low: 512.50, close: 515.50 },
  { id: "30", date: "2023-04-30", open: 518.80, high: 520.90, low: 507.10, close: 508.45 },
  { id: "31", date: "2023-05-01", open: 509.80, high: 526.40, low: 504.75, close: 524.95 },
  { id: "32", date: "2023-05-02", open: 524.95, high: 527.00, low: 519.35, close: 522.50 },
  { id: "33", date: "2023-05-03", open: 522.50, high: 531.00, low: 521.15, close: 528.50 },
  { id: "34", date: "2023-05-04", open: 527.15, high: 529.65, low: 519.15, close: 520.20 },
  { id: "35", date: "2023-05-05", open: 518.00, high: 518.00, low: 509.10, close: 514.85 },
  { id: "36", date: "2023-05-06", open: 514.90, high: 519.75, low: 512.20, close: 518.45 },
  { id: "37", date: "2023-05-07", open: 525.00, high: 525.10, low: 519.70, close: 521.45 },
  { id: "38", date: "2023-05-08", open: 521.45, high: 523.50, low: 518.00, close: 518.80 },
  { id: "39", date: "2023-05-09", open: 527.5, high: 536.25, low: 522.85, close: 535.2 },
  { id: "40", date: "2023-05-10", open: 537, high: 541.25, low: 532.75, close: 535.9 },
  { id: "41", date: "2023-05-11", open: 539, high: 548.8, low: 537.9, close: 546.25 },
  { id: "42", date: "2023-05-12", open: 549.45, high: 557.00, low: 545.35, close: 555.75 },
  { id: "43", date: "2023-05-13", open: 558.80, high: 575.00, low: 552.15, close: 567.95 },
  { id: "44", date: "2023-05-14", open: 570.00, high: 576.55, low: 557.00, close: 559.70 },
  { id: "45", date: "2023-05-15", open: 564.4, high: 566.45, low: 559.3, close: 562.3 },
  { id: "46", date: "2023-05-16", open: 567, high: 568.9, low: 560.65, close: 564.20 },
  { id: "47", date: "2023-05-17", open: 567.7, high: 571.05, low: 560.75, close: 562.20 },
  { id: "48", date: "2023-05-18", open: 566, high: 571.2, low: 564, close: 570.3 },
  { id: "49", date: "2023-05-19", open: 571.8, high: 575, low: 567.75, close: 568.45 },
  { id: "50", date: "2023-05-20", open: 569.65, high: 572.2, low: 566.05, close: 569.8 },
  { id: "51", date: "2023-05-21", open: 570.65, high: 573.2, low: 564.2, close: 566 },
  { id: "52", date: "2023-05-22", open: 566, high: 583.95, low: 562.5, close: 583.25 },
  { id: "53", date: "2023-05-23", open: 584.95, high: 585.9, low: 574.5, close: 581.4 },
  { id: "54", date: "2023-05-24", open: 584, high: 584.7, low: 568.2, close: 569.35 },
  { id: "55", date: "2023-05-25", open: 570, high: 571.15, low: 557.8, close: 559.65 },
  { id: "56", date: "2023-05-26", open: 588.35, high: 599, low: 588, close: 595.55 },
  { id: "57", date: "2023-05-27", open: 570, high: 576.9, low: 568.45, close: 573.1 },
  { id: "58", date: "2023-05-28", open: 579, high: 590, low: 575.5, close: 586.65 },
  { id: "59", date: "2023-05-29", open: 588.35, high: 599.00, low: 588.00, close: 595.55 },
  { id: "60", date: "2023-05-30", open: 600.00, high: 602.30, low: 590.00, close: 590.80 },
  { id: "61", date: "2023-05-31", open: 594.40, high: 596.40, low: 589.50, close: 591.45 },
  { id: "62", date: "2023-06-01", open: 592.00, high: 593.00, low: 584.95, close: 588.25 },
  { id: "63", date: "2023-06-02", open: 590.80, high: 604.95, low: 588.55, close: 600.80 },
  { id: "64", date: "2023-06-03", open: 600.00, high: 624.80, low: 592.20, close: 618.20 },
  { id: "65", date: "2023-06-04", open: 624.00, high: 634.80, low: 617.55, close: 618.65 },
  { id: "66", date: "2023-06-05", open: 624.95, high: 630.45, low: 622.15, close: 628.50 },
  { id: "67", date: "2023-06-06", open: 629.95, high: 630.80, low: 619.35, close: 621.45 },
  { id: "68", date: "2023-06-07", open: 625.00, high: 626.50, low: 615.50, close: 620.65 },
  { id: "69", date: "2023-06-08", open: 623.00, high: 626.00, low: 619.50, close: 624.90 },
  { id: "70", date: "2023-06-09", open: 626.90, high: 627.00, low: 617.15, close: 618.50 },
  { id: "71", date: "2023-06-10", open: 620.40, high: 620.85, low: 607.00, close: 612.10 },
  { id: "72", date: "2023-06-11", open: 614.00, high: 625.30, low: 610.15, close: 620.60 },
  { id: "73", date: "2023-06-12", open: 622.65, high: 623.60, low: 616.20, close: 621.65 },
  { id: "74", date: "2023-06-13", open: 621.00, high: 631.00, low: 617.70, close: 625.75 },
  { id: "75", date: "2023-06-14", open: 627.95, high: 634.45, low: 626.25, close: 629.25 },
  { id: "76", date: "2023-06-15", open: 636.00, high: 642.50, low: 633.35, close: 639.45 },
  { id: "77", date: "2023-06-16", open: 640.00, high: 665.40, low: 639.00, close: 641.10 },
  { id: "78", date: "2023-06-17", open: 647.00, high: 648.45, low: 636.75, close: 643.70 },
  { id: "79", date: "2023-06-18", open: 646.00, high: 646.00, low: 631.80, close: 635.30 }
];

export const candleData2 = [
  { id: "1", date: "2023-04-01", open: 423.00, high: 424.95, low: 419.50, close: 424.25 },
  { id: "2", date: "2023-04-02", open: 424.25, high: 428.75, low: 423.15, close: 426.55 },
  { id: "3", date: "2023-04-03", open: 426.50, high: 439.30, low: 423.75, close: 437.65 },
  { id: "4", date: "2023-04-04", open: 452.05, high: 473.30, low: 452.00, close: 461.30 },
  { id: "5", date: "2023-04-05", open: 463.75, high: 463.75, low: 455.80, close: 458.70 },
  { id: "6", date: "2023-04-06", open: 459.35, high: 468.60, low: 458.20, close: 465.50 },
  { id: "7", date: "2023-04-07", open: 464.95, high: 472.00, low: 463.25, close: 469.50 },
  { id: "8", date: "2023-04-08", open: 471.00, high: 473.00, low: 465.65, close: 472.15 },
  { id: "9", date: "2023-04-09", open: 475.00, high: 483.35, low: 468.10, close: 473.00 },
  { id: "10", date: "2023-04-10", open: 473.00, high: 475.50, low: 467.85, close: 469.40 },
  { id: "11", date: "2023-04-11", open: 473.70, high: 479.70, low: 469.40, close: 476.80 },
  { id: "12", date: "2023-04-12", open: 476.70, high: 476.70, low: 467.20, close: 471.20 },
  { id: "13", date: "2023-04-13", open: 471.20, high: 476.00, low: 468.30, close: 475.20 },
  { id: "14", date: "2023-04-14", open: 475.20, high: 476.40, low: 471.90, close: 473.55 },
  { id: "15", date: "2023-04-15", open: 473.00, high: 479.50, low: 472.60, close: 478.20 },
  { id: "16", date: "2023-04-16", open: 478.50, high: 482.00, low: 476.50, close: 481.60 },
  { id: "17", date: "2023-04-17", open: 481.40, high: 488.00, low: 478.35, close: 484.95 },
  { id: "18", date: "2023-04-18", open: 482.50, high: 484.00, low: 474.55, close: 480.25 },
  { id: "19", date: "2023-04-19", open: 480.25, high: 485.10, low: 477.75, close: 483.70 },
  { id: "20", date: "2023-04-20", open: 483.60, high: 486.40, low: 478.75, close: 480.80 },
  { id: "21", date: "2023-04-21", open: 481.65, high: 484.70, low: 476.15, close: 477.10 },
  { id: "22", date: "2023-04-22", open: 480.00, high: 502.30, low: 478.10, close: 500.50 },
  { id: "23", date: "2023-04-23", open: 502.00, high: 512.80, low: 501.55, close: 503.65 },
  { id: "24", date: "2023-04-24", open: 508.00, high: 512.90, low: 504.35, close: 509.50 },
  { id: "25", date: "2023-04-25", open: 512.00, high: 514.15, low: 505.50, close: 511.60 },
  { id: "26", date: "2023-04-26", open: 513.90, high: 520.50, low: 510.30, close: 515.95 },
  { id: "27", date: "2023-04-27", open: 523.85, high: 537.15, low: 521.50, close: 530.85 },
  { id: "28", date: "2023-04-28", open: 533.95, high: 535.95, low: 518.85, close: 521.15 },
  { id: "29", date: "2023-04-29", open: 522.50, high: 523.95, low: 512.50, close: 515.50 },
  { id: "30", date: "2023-04-30", open: 518.80, high: 520.90, low: 507.10, close: 508.45 },
  { id: "31", date: "2023-05-01", open: 509.80, high: 526.40, low: 504.75, close: 524.95 },
  { id: "32", date: "2023-05-02", open: 524.95, high: 527.00, low: 519.35, close: 522.50 },
  { id: "33", date: "2023-05-03", open: 522.50, high: 531.00, low: 521.15, close: 528.50 },
  { id: "34", date: "2023-05-04", open: 527.15, high: 529.65, low: 519.15, close: 520.20 },
  { id: "35", date: "2023-05-05", open: 518.00, high: 518.00, low: 509.10, close: 514.85 },
  { id: "36", date: "2023-05-06", open: 514.90, high: 519.75, low: 512.20, close: 518.45 },
  { id: "37", date: "2023-05-07", open: 525.00, high: 525.10, low: 519.70, close: 521.45 },
  { id: "38", date: "2023-05-08", open: 521.45, high: 523.50, low: 518.00, close: 518.80 },
  { id: "39", date: "2023-05-09", open: 527.5, high: 536.25, low: 522.85, close: 535.2 },
  { id: "40", date: "2023-05-10", open: 537, high: 541.25, low: 532.75, close: 535.9 },
  { id: "41", date: "2023-05-11", open: 539, high: 548.8, low: 537.9, close: 546.25 },
  { id: "42", date: "2023-05-12", open: 549.45, high: 557.00, low: 545.35, close: 555.75 },
  { id: "43", date: "2023-05-13", open: 558.80, high: 575.00, low: 552.15, close: 567.95 },
  { id: "44", date: "2023-05-14", open: 570.00, high: 576.55, low: 557.00, close: 559.70 },
  { id: "45", date: "2023-05-15", open: 564.4, high: 566.45, low: 559.3, close: 562.3 },
  { id: "46", date: "2023-05-16", open: 567, high: 568.9, low: 560.65, close: 564.20 },
  { id: "47", date: "2023-05-17", open: 567.7, high: 571.05, low: 560.75, close: 562.20 },
  { id: "48", date: "2023-05-18", open: 566, high: 571.2, low: 564, close: 570.3 },
  { id: "49", date: "2023-05-19", open: 571.8, high: 575, low: 567.75, close: 568.45 },
  { id: "50", date: "2023-05-20", open: 569.65, high: 572.2, low: 566.05, close: 569.8 },
  { id: "51", date: "2023-05-21", open: 570.65, high: 573.2, low: 564.2, close: 566 },
  { id: "52", date: "2023-05-22", open: 566, high: 583.95, low: 562.5, close: 583.25 },
  { id: "53", date: "2023-05-23", open: 584.95, high: 585.9, low: 574.5, close: 581.4 },
  { id: "54", date: "2023-05-24", open: 584, high: 584.7, low: 568.2, close: 569.35 },
  { id: "55", date: "2023-05-25", open: 570, high: 571.15, low: 557.8, close: 559.65 },
  { id: "56", date: "2023-05-26", open: 588.35, high: 599, low: 588, close: 595.55 },
  { id: "57", date: "2023-05-27", open: 570, high: 576.9, low: 568.45, close: 573.1 },
  { id: "58", date: "2023-05-28", open: 579, high: 590, low: 575.5, close: 586.65 },
  { id: "59", date: "2023-05-29", open: 588.35, high: 599.00, low: 588.00, close: 595.55 },
  { id: "60", date: "2023-05-30", open: 600.00, high: 602.30, low: 590.00, close: 590.80 },
  { id: "61", date: "2023-05-31", open: 594.40, high: 596.40, low: 589.50, close: 591.45 },
  { id: "62", date: "2023-06-01", open: 592.00, high: 593.00, low: 584.95, close: 588.25 },
  { id: "63", date: "2023-06-02", open: 590.80, high: 604.95, low: 588.55, close: 600.80 },
  { id: "64", date: "2023-06-03", open: 600.00, high: 624.80, low: 592.20, close: 618.20 },
  { id: "65", date: "2023-06-04", open: 624.00, high: 634.80, low: 617.55, close: 618.65 },
  { id: "66", date: "2023-06-05", open: 624.95, high: 630.45, low: 622.15, close: 628.50 },
  { id: "67", date: "2023-06-06", open: 629.95, high: 630.80, low: 619.35, close: 621.45 },
  { id: "68", date: "2023-06-07", open: 625.00, high: 626.50, low: 615.50, close: 620.65 },
  { id: "69", date: "2023-06-08", open: 623.00, high: 626.00, low: 619.50, close: 624.90 },
  { id: "70", date: "2023-06-09", open: 626.90, high: 627.00, low: 617.15, close: 618.50 },
  { id: "71", date: "2023-06-10", open: 620.40, high: 620.85, low: 607.00, close: 612.10 },
  { id: "72", date: "2023-06-11", open: 614.00, high: 625.30, low: 610.15, close: 620.60 },
  { id: "73", date: "2023-06-12", open: 622.65, high: 623.60, low: 616.20, close: 621.65 },
  { id: "74", date: "2023-06-13", open: 621.00, high: 631.00, low: 617.70, close: 625.75 },
  { id: "75", date: "2023-06-14", open: 627.95, high: 634.45, low: 626.25, close: 629.25 },
  { id: "76", date: "2023-06-15", open: 636.00, high: 642.50, low: 633.35, close: 639.45 },
  { id: "77", date: "2023-06-16", open: 640.00, high: 665.40, low: 639.00, close: 641.10 },
  { id: "78", date: "2023-06-17", open: 647.00, high: 648.45, low: 636.75, close: 643.70 },
  { id: "79", date: "2023-06-18", open: 646.00, high: 646.00, low: 631.80, close: 635.30 }
];

const parseDate = d3.timeParse("%Y-%m-%d");

candleData2.forEach((d) => {
    d.date = parseDate(d.date);
});

export const sunBrustData = {
  name: "World",
  children: [
    {
      name: "India",
      labelName: "IND",
      children: [
        {
          name: "Uttar Pradesh",
          labelName: "UP",
          children: [
            { name: "Lucknow", labelName: "LK", value: 50 },
            { name: "Agra", labelName: "AG", value: 30 },
          ],
        },
        {
          name: "Gujarat",
          labelName: "GUJ",
          children: [
            { name: "Surat", labelName: "SU", value: 40 },
            { name: "Rajkot", labelName: "RJ", value: 25 },
          ],
        },
        {
          name: "Maharashtra",
          labelName: "MH",
          children: [
            { name: "Mumbai", labelName: "MI", value: 70 },
            { name: "Pune", labelName: "PU", value: 40 },
          ],
        },
      ],
    },
    {
      name: "China",
      labelName: "CN",
      children: [
        {
          name: "Guangdong",
          labelName: "GUD",
          children: [
            { name: "Guangzhou", labelName: "GH", value: 50 },
            { name: "Shenzhen", labelName: "SH", value: 20 },
          ],
        },
        {
          name: "Zhejiang",
          labelName: "ZHJ",
          children: [
            { name: "Hangzhou", labelName: "HZ", value: 35 },
            { name: "Ningbo", labelName: "NB", value: 30 },
          ],
        },
        {
          name: "Jiangsu",
          labelName: "JIG",
          children: [
            { name: "Suzhou", labelName: "SH", value: 50 },
            { name: "Nanjing", labelName: "NJ", value: 35 },
          ],
        },
      ],
    },
    {
      name: "USA",
      labelName: "USA",
      children: [
        {
          name: "California",
          labelName: "CA",
          children: [
            { name: "Los Angeles", labelName: "LA", value: 30 },
            { name: "San Francisco", labelName: "SF", value: 20 },
          ],
        },
        {
          name: "Texas",
          labelName: "TX",
          children: [
            { name: "Houston", labelName: "HUS", value: 20 },
            { name: "Dallas", labelName: "DA", value: 30 },
          ],
        },
        {
          name: "Florida",
          labelName: "FD",
          children: [
            { name: "Miami", labelName: "MI", value: 10 },
            { name: "Orlando", labelName: "OL", value: 20 },
          ],
        },
      ],
    },
    {
      name: "Australia",
      labelName: "AUS",
      children: [
        {
          name: "New South Wales",
          labelName: "NSW",
          children: [
            { name: "Sydney", labelName: "SY", value: 15 },
            { name: "Newcastle", labelName: "NC", value: 8 },
          ],
        },
        {
          name: "Victoria",
          labelName: "VC",
          children: [
            { name: "Melbourne", labelName: "MLB", value: 18 },
            { name: "Geelong", labelName: "GL", value: 5 },
          ],
        },
        {
          name: "Queensland",
          labelName: "QL",
          children: [
            { name: "Brisbane", labelName: "BB", value: 12 },
            { name: "Gold Coast", labelName: "GC", value: 10 },
          ],
        },
      ],
    },
  ],
};
